import { Phone, Camera } from "lucide-react";
import { IMAGES, PHONE_TEL } from "@/lib/contact";

export const Hero = () => (
  <section data-testid="hero-section" className="stage relative isolate overflow-hidden bg-steelhero text-white min-h-[640px] flex items-end">
    <div className="absolute inset-0">
      {IMAGES.hero.map((img) => (
        <figure key={img.label} className="fr absolute inset-0 m-0">
          <img src={img.src} alt={img.alt} className="absolute inset-0 w-full h-full object-cover" />
          <figcaption className="lb absolute top-6 right-6 bg-white text-ink px-2 py-1">{img.label}</figcaption>
        </figure>
      ))}
    </div>
    <div className="relative z-10 w-full bg-gradient-to-t from-black/85 via-black/60 to-black/10 px-6 pt-32 pb-12">
      <p className="lb mb-4 text-peach">Rossz, Megunt vagy Szakadt · Budapest és 30 km-es körzete</p>
      <h1 className="mo" data-testid="hero-headline">
        <span className="ln"><span>Kanapé Elszállítás</span></span>
        <span className="ln"><span>Akár 24 Órán Belül</span></span>
      </h1>
      <p className="f1 mt-6 max-w-[60ch] text-white">
        Nem kell cipelnie és bajlódnia vele! Szétkapcsoljuk, levisszük a lakásból (akár a 4. emeletről is lift nélkül), és elszállítjuk.
      </p>
      <div className="f2 mt-8 flex flex-wrap gap-4 items-center">
        <a href={PHONE_TEL} data-testid="hero-call-button" className="btn-press mo inline-flex items-center gap-2 px-6 py-4 bg-signal text-ink">
          <Phone className="w-5 h-5" aria-hidden="true" /> Azonnali Hívás
        </a>
        <a href="#ajanlat" data-testid="hero-photo-button" className="btn-press mo inline-flex items-center gap-2 px-6 py-4 bg-white text-transport">
          <Camera className="w-5 h-5" aria-hidden="true" /> Fotó Küldése – Gyors Ár
        </a>
      </div>
    </div>
  </section>
);
